import ProfilePicture from '../components/ProfilePicture';
import Title from '../components/Title';
import Paragraph from '../components/Paragraph';

const openers = ["Hi!", "Hello!", "What's good?", "What's up?", "Good to see you here!", "yo"]

function Home() {
    return (
      <>
        <ProfilePicture/>
        <Title text={openers[Math.floor(Math.random() * openers.length)]} fontSize={5}/>
        <Paragraph fontSize={2.2} maxWidth={70}>
          I'm Catalin, and online I go by Sapokee. Here, you can
          find basically all of the things I do, mainly music and
          programming. Feel free to browse around. 
        </Paragraph>
      </>
    );
  }
  
  export default Home;